import { update } from 'state/util';

// which prompts to render, note that this only
// supports displaying one prompt at a time
export const PROMPTS = {
  NONE:  0,
  LOGIN: 1,
};

const initialState = {
  status: PROMPTS.NONE,
};

export const promptReducer = (state=initialState, action) => {
  if (action.type === "LOGOUT_REQUESTED") {
    return initialState;
  }
  if (action.type === "SHOW_LOGIN_PROMPT") {
    return update(state, {
      status: PROMPTS.LOGIN,
    });
  }
  else if (action.type === "DISMISS_PROMPT") {
    return update(state, {
      status: PROMPTS.NONE,
    });
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/state/prompt/reducer.js